
export default function Experts() {
  const experts = [
    {
      name: "大和谷 朱美",
      title: "総合ディレクター・化粧品開発専門家",
      experience: "45年間の化粧品・ヘアケア開発経験",
      description: "長年にわたり化粧品開発とヘアケア開発に情熱を傾け、数多くの製品を世に送り出してきました。その豊富な経験と知識を活かし、お客様一人ひとりに最適なケアをコーディネートいたします。",
      image: "https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/e67bd57b37818939c2ef64f9748c1ff4.png"
    },
    {
      name: "出口 アヤ",
      title: "エステティック監修・著書多数",
      experience: "エステサロン再生・教育のスペシャリスト",
      description: "長年エステサロンの再生とエステティシャンの教育に携わり、多数の著書を出版。テレビ出演も多数。その豊富な実績と経験で、サロン運営から技術指導まで幅広くサポートいたします。",
      image: "https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/12bf15b818ccd61adead1c5b7bd3bab2.jfif"
    }
  ];

  const advisors = [
    {
      name: "飯島 隆太郎 医師",
      title: "医学監修",
      specialty: "皮膚科・美容医学専門",
      image: "https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/8499d17936f1c3478fd610532e5d55ce.png"
    },
    {
      name: "和田 裕太郎 医師",
      title: "医学監修",
      specialty: "内科・統合医療専門",
      image: "https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/4ed544d3a303b94e680bbe080c67b7b5.jfif"
    },
    {
      name: "三木 健輔 博士",
      title: "アーユルヴェーダ研究者",
      specialty: "横浜市立大学 客員准教授 / 博士（理学）",
      image: "https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/6b88af1939d7c530c16dc263c8d176b2.jfif"
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            専門家チーム
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto px-2">
            豊富な経験と専門知識を持つプロフェッショナルが、
            お客様の美と健康をサポートいたします。
          </p>
        </div>

        {/* メイン専門家 */}
        <div className="mb-16 sm:mb-20">
          <h3 className="text-2xl sm:text-3xl font-bold text-center text-gray-900 mb-8 sm:mb-12">コーディネーター</h3>
          <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 max-w-6xl mx-auto">
            {experts.map((expert, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6 sm:p-8 text-center">
                <img 
                  src={expert.image}
                  alt={expert.name}
                  className="w-24 h-24 sm:w-32 sm:h-32 rounded-full mx-auto mb-4 sm:mb-6 object-cover object-top"
                />
                <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-2">{expert.name}</h4>
                <p className="text-amber-600 font-semibold mb-2 text-sm sm:text-base">{expert.title}</p>
                <p className="text-gray-600 text-xs sm:text-sm mb-3 sm:mb-4">{expert.experience}</p>
                <p className="text-gray-700 leading-relaxed text-sm sm:text-base">{expert.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* 監修・顧問 */}
        <div>
          <h3 className="text-2xl sm:text-3xl font-bold text-center text-gray-900 mb-8 sm:mb-12">医学監修・顧問</h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {advisors.map((advisor, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-4 sm:p-6 text-center">
                <img 
                  src={advisor.image}
                  alt={advisor.name}
                  className="w-20 h-20 sm:w-24 sm:h-24 rounded-full mx-auto mb-3 sm:mb-4 object-cover object-top"
                />
                <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">{advisor.name}</h4>
                <p className="text-amber-600 font-semibold mb-2 text-sm sm:text-base">{advisor.title}</p>
                <p className="text-gray-600 text-xs sm:text-sm">{advisor.specialty}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
